import ScreeningAssessment, {
  ScreeningAssessmentProps,
} from "../ScreeningAssessment";
import { HOME_HEALTH_SCREENER_TYPES } from "../assessment-constant";

export type DiabeticAssessmentProps = Omit<ScreeningAssessmentProps, "type">;

const DiabeticAssessment = (props: DiabeticAssessmentProps) => (
  <ScreeningAssessment {...props} type={HOME_HEALTH_SCREENER_TYPES.diabetic} />
);

export default DiabeticAssessment;
